// extracted by mini-css-extract-plugin
export default {"chatContainer":"kvi_jmLdu_xLT0Cd-U3fX","emptyMessagesContainer":"_31Dvv7LuupMgrQNH6YhbNQ"};